import { ErrorMessage } from '../../typings/error';
import { getErrorMessageByCode } from './errorGlossary';
import { InvitationError } from '../../typings/participant';

export const findLatestError = (
    participantErrors: InvitationError | undefined,
): ErrorMessage | undefined => {
    const errors = participantErrors ? Object.entries(participantErrors) : [];
    const latestStatusEntry = errors.sort(
        ([date1], [date2]) =>
            new Date(date2).getTime() - new Date(date1).getTime(),
    )[0];

    if (!latestStatusEntry) {
        return undefined;
    }

    const [, latestErrorCode] = latestStatusEntry;
    const errorMessages = getErrorMessageByCode(latestErrorCode);

    if (!errorMessages) {
        return undefined;
    }

    return errorMessages;
};
